import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import "./OrderQueueSummaryCard.css";
import queueImg from "./../../../../assets/images/queue.png";
import pendingImg from "./../../../../assets/images/pending.png";
import preparingImg from "./../../../../assets/images/preparing.png";
import readyImg from "./../../../../assets/images/ready.png";

const OrderQueueSummaryCard = (props) => {
  const activeTab = props.activeTab;
  return (
    <div>
      <Grid container className="mb-2">
        <Grid xs={3} className="box-container">
          <Card className="commonCards queueCard">
            <CardContent>
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  opacity: activeTab.includes('queued') ? 0.2 : 1
                }}
                onClick={props.onQueuedClick}
              >
                <div
                  className="d-flex"
                  style={{
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Queued
                  </Typography>
                  <Typography variant="h3" sx={{ color: "white" }}>
                    {props.quantityQueued.queuedQty}
                  </Typography>
                </div>
                <div>
                  <img
                    src={queueImg}
                    alt=""
                    style={{ width: "5rem", opacity: ".5" }}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid xs={3} className="box-container">
          <Card className="commonCards pendingCard">
            <CardContent>
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  opacity: activeTab.includes('pending') ? 0.2 : 1
                }}
                onClick={props.onPendingClick}
              >
                <div
                  className="d-flex"
                  style={{
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Pending
                  </Typography>
                  <Typography variant="h3" sx={{ color: "white" }}>
                    {props.quantityQueued.pendingQty}
                  </Typography>
                </div>
                <div>
                  <img
                    src={pendingImg}
                    alt=""
                    style={{ width: "5rem", opacity: ".5" }}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid xs={3} className="box-container">
          <Card className="commonCards preparingCard">
            <CardContent>
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  opacity: activeTab.includes('preparing') ? 0.2 : 1
                }}
                onClick={props.onPreparingClick}
              >
                <div
                  className="d-flex"
                  style={{
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Preparing
                  </Typography>
                  <Typography variant="h3" sx={{ color: "white" }}>
                    {props.quantityQueued.preparingQty}
                  </Typography>
                </div>
                <div>
                  <img
                    src={preparingImg}
                    alt=""
                    style={{ width: "5rem", opacity: ".5" }}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid xs={3} className="box-container">
          <Card className="commonCards readyCard">
            <CardContent>
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  opacity: activeTab.includes('ready') ? 0.2 : 1
                }}
                onClick={props.onReadyClick}
              >
                <div
                  className="d-flex"
                  style={{
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Ready
                  </Typography>
                  <Typography variant="h3" sx={{ color: "white" }}>
                    {props.quantityQueued.readyQty}
                  </Typography>
                </div>
                <div>
                  <img
                    src={readyImg}
                    alt=""
                    style={{ width: "5rem", opacity: ".5" }}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default OrderQueueSummaryCard;
